import axios from 'axios';

const API_BASE = '/api/vendors';

export const vendorService = {
  getAll: async (params = {}) => {
    const response = await axios.get(API_BASE, { params });
    return response.data;
  },

  getById: async (id) => {
    const response = await axios.get(`${API_BASE}/${id}`);
    return response.data;
  },

  create: async (vendorData) => {
    const response = await axios.post(API_BASE, vendorData);
    return response.data;
  },

  update: async (id, vendorData) => {
    const response = await axios.put(`${API_BASE}/${id}`, vendorData);
    return response.data;
  },

  delete: async (id) => {
    const response = await axios.delete(`${API_BASE}/${id}`);
    return response.data;
  }
};
